import axios from 'axios';
//TODO: Remover axios e usar fetch nativo
// Use NEXT_PUBLIC_ for client-side environment variables
const API_BASE_URL = import.meta.env.VITE_PUBLIC_API_URL || 'http://localhost:8000'; // Default fallback
const OLD_API_BASE_URL = import.meta.env.VITE_OLD_PUBLIC_API_URL || 'http://localhost'

// ============================================
// 1. API PARA JSON (chamadas normais)
// ============================================
const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
    withCredentials: true,
});

// ============================================
// 2. API PARA FORM_DATA (emails, uploads)
// ============================================
const apiFormData = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: true,
});

// ============================================
// CONFIGURAÇÕES COMUNS
// ============================================

// Adiciona token de autenticação em ambas
[api, apiFormData].forEach(instance => {
    instance.interceptors.request.use(
        (config) => {
            // Check if we are in browser environment
            if (typeof window !== 'undefined') {
                const token = localStorage.getItem('sanctum_token');
                if (token) {
                    config.headers.Authorization = `Bearer ${token}`;
                }
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    // Trata erro 401 (não autorizado) e decodifica entidades HTML
    instance.interceptors.response.use(
        (response) => {
            // Decodifica entidades HTML em todas as strings da resposta de forma recursiva
            if (response.data && !(response.data instanceof Blob)) {
                const decodeRecursive = (data: any): any => {
                    if (Array.isArray(data)) {
                        return data.map(decodeRecursive);
                    } else if (data !== null && typeof data === 'object') {
                        const obj: any = {};
                        for (const key in data) {
                            obj[key] = decodeRecursive(data[key]);
                        }
                        return obj;
                    } else if (typeof data === 'string') {
                        // Usando um parser temporário para decodificar
                        const txt = document.createElement("textarea");
                        txt.innerHTML = data;
                        return txt.value;
                    }
                    return data;
                };
                response.data = decodeRecursive(response.data);
            }
            return response;
        },
        (error) => {
            if (error.response?.status === 401) {
                const requestUrl = error.config?.url || '';
                const isLoginEndpoint = requestUrl.includes('/login');

                if (typeof window !== 'undefined' && !isLoginEndpoint) {
                    localStorage.removeItem('sanctum_token');
                    localStorage.removeItem('accessToken');
                    window.dispatchEvent(new CustomEvent('fdc:session_expired'));
                }
            }
            return Promise.reject(error);
        }
    );
});

// Configuração especial para FormData
apiFormData.interceptors.request.use(
    (config) => {
        // Se for FormData, remove Content-Type (o browser define)
        if (config.data instanceof FormData) {
            delete config.headers['Content-Type'];
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// ============================================
// 3. API PARA JSON (chamadas normais)
// ============================================
const apiOld = axios.create({
    baseURL: OLD_API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
    withCredentials: true,
});

// ============================================
// EXPORTAÇÕES
// ============================================
export { api, apiFormData, apiOld };
export default api;
